import * as ACT from '../actions/reminderActions';

export function reminder(state = {}, action) {
    switch (action.type) {


        case ACT.REMINDER_SET_ALL:
            return {
                ...state,
                list: action.data,
            };
        case ACT.REMINDER_SET_ALL_FOR_EXCEL:
            return {
                ...state,
                listForExcel: action.data,
            };


        case ACT.REMINDER_FIELD_ERROR:
            if (state.fieldsError)
                var fieldsErrorPushed = state.fieldsError;
            else
                fieldsErrorPushed = {};
            fieldsErrorPushed[action.fieldName] = (action.fieldData != {}) ? action.fieldData : {err: true};


            return {
                ...state,
                fieldsError: fieldsErrorPushed,
                formError: true,
            };
        case ACT.REMINDER_FIELD_RESET_ERROR:
            return {
                ...state,
                fieldsError: {},
                formError: false,
            };


        default:
            return state
    }
};
